import ListProcesses from "@/views/organization/process/work_logs/ListProcesses.vue";
import ShowProcess from "@/views/organization/process/work_logs/ShowProcess.vue";
import NewHarvestTeamWorkLog from "@/views/organization/process/work_logs/NewHarvestTeamWorkLog.vue";
import EditHarvestTeamWorkLog from "@/views/organization/process/work_logs/EditHarvestTeamWorkLog.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "process",
  permission: "work_logs",
});

export default [
  {
    path: "/org/:organization_id/process/work_logs/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") },
  },
  {
    path: "/org/:organization_id/process/work_logs/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META,
  },
  {
    path: "/org/:organization_id/process/work_logs/show_process/:harvest_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META,
  },
  {
    path: "/org/:organization_id/process/work_logs/:harvest_process_id/new",
    name: routeName("new_harvest_team_work_log"),
    component: NewHarvestTeamWorkLog,
    props: true,
    meta: META,
  },
  {
    path: "/org/:organization_id/process/work_logs/:harvest_process_id/edit/:harvest_team_work_log_id",
    name: routeName("edit_harvest_team_work_log"),
    component: EditHarvestTeamWorkLog,
    props: true,
    meta: META,
  },
];
